import { render, staticRenderFns } from "./SocialProofBar.vue?vue&type=template&id=c64761f4&scoped=true"
import script from "./SocialProofBar.vue?vue&type=script&lang=js"
export * from "./SocialProofBar.vue?vue&type=script&lang=js"
import style0 from "./SocialProofBar.vue?vue&type=style&index=0&id=c64761f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64761f4",
  null
  
)

export default component.exports